import React from "react";
import TyreStore from '../../../stores/tyre_store';
import Input from '../../form/input';
import Translation from '../../translation/translation';
import TranslationContainer from '../../translation/translation_container';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import getTranslatedText from '../../../helper/get_translated_text';
import PostcodeAutocomplete, { showAutoCompletePostcodeSelector } from '../../PostcodeAutocomplete';

const lazyFormClassNames = generateClassName({
    'fsf-stations-update-postcode': true,
    'has-validation-error': ({ postcodeInvalid }) => postcodeInvalid,
});

class FinderStationListHeaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this._onPostcodeChange = this._onPostcodeChange.bind(this);
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this.showAutoCompletePostcode = showAutoCompletePostcodeSelector(this.props.store);
    }

    render() {
        const props = this.props;
        const { showChangePostcodeForm, postcode } = props;
        const priceSortingAttr = TyreStore.getState().id ? 'cart' : 'price';
        const actionsStyle = { display: showChangePostcodeForm ? 'none' : 'block' };
        const formStyle = { display: showChangePostcodeForm ? 'block' : 'none' };
        const availableQuantitiesItems = [];
        const transSelectTyre = getTranslatedText('fitting-station-finder-app-select-tyre');
        const transSelectTyres = getTranslatedText('fitting-station-finder-app-select-tyres');
        if (typeof props.availableQuantities !== 'undefined' && props.availableQuantities.length > 0) {
            let index = 0;
            props.availableQuantities.forEach((value) => {
                let tyreWord = (value === 1) ? transSelectTyre : transSelectTyres;
                let tyreOptionLabel = value + ' ' + tyreWord;
                availableQuantitiesItems.push(<option value={value} key={index}>
                    {tyreOptionLabel}
                </option>);
                index++;
            });
        }

        let sortClass = 'fsf-stations-header__sorting sort-clickable ';
        let sortedByPrice = sortClass.concat(this._highlightSort('price'));
        let sortedByDistance = sortClass.concat(this._highlightSort('distance'));
        let sortedByRating = sortClass.concat(this._highlightSort('rating'));
        const quantityVisibilityStyle = { visibility: props.showQuantityInput ? 'visible' : 'hidden' };
        return (
            <div className="fsf-stations-header">
                <div className="fsf-stations-header__actions" style={actionsStyle}>
                    {
                        <div className="fsf-stations-header__quantity">
                            <label>
                                <div className="styled-select wider-quantity-select" style={quantityVisibilityStyle}>
                                    <select
                                        className="fsf-stations-header__quantity-select"
                                        value={props.productsQty}
                                        onChange={this._onQuantityChange}
                                    >
                                        {availableQuantitiesItems}
                                    </select>
                                </div>
                            </label>
                        </div>
                    }
                    <div className="fsf-stations-header__current-postcode">
                        <span className="fsf-stations-header__current-postcode-text">{postcode ? postcode.split(',')[0] : ''}</span>
                        <button
                            className="fsf-stations-header__change-postcode"
                            onClick={props.onChangePostcodeClick}
                        >
                            <Translation translationKey="fitting-station-finder-app-change-postcode" />
                        </button>
                    </div>
                </div>
                <div className="fsf-stations-header__actions header-sorting-action" style={actionsStyle}>
                    <div className="fsf-stations-header__sorting">
                        {getTranslatedText('fitting-station-finder-app-header-sort-by')}
                    </div>
                    <div className={sortedByDistance} onClick={() => props.onSortingChange('distance')}>
                        {getTranslatedText('fitting-station-finder-app-sort-by-distance-asc')}
                    </div>
                    <div className={sortedByPrice} onClick={() => props.onSortingChange(priceSortingAttr)}>
                        {getTranslatedText('fitting-station-finder-app-sort-by-price-asc')}
                    </div>
                    <div className={sortedByRating} onClick={() => props.onSortingChange('rating')}>
                        {getTranslatedText('fitting-station-finder-app-sort-by-rating-desc')}
                    </div>
                </div>
                <form
                    ref="form"
                    className={lazyFormClassNames(props)}
                    style={formStyle}
                    onSubmit={props.onPostcodeSubmit}
                >

                    {
                        !this.showAutoCompletePostcode
                        && <TranslationContainer translationKey="form-placeholder-postcode" targetProperty="placeholder">
                            <Input
                                ref="postcode"
                                className="fsf-stations-update-postcode__input"
                                type="input"
                                value={props.postcode}
                                onChange={this._onPostcodeChange}
                            />
                        </TranslationContainer>
                    }

                    {
                        this.showAutoCompletePostcode
                        && <PostcodeAutocomplete value={props.postcode}
                            onChange={this._onPostcodeChange}
                            name="postcode"
                            selectSuggestion={props.selectPostcodeSuggestion}
                            native>
                            <Input
                                ref="postcode"
                                className="fsf-stations-update-postcode__input"
                                type="input"
                                value={props.postcode}
                                onChange={this._onPostcodeChange}
                                placeholder={getTranslatedText('postcode-form-postcode-autosuggest-label')}
                                autoComplete="off"
                            />

                        </PostcodeAutocomplete>
                    }
                    <div className="fsf-stations-update-postcode__postcode-error-msg postcode-form__error-msg postcode-error-msg">
                        <span className="postcode-error-msg__label">
                            {props.postcodeInvalidMessage}
                        </span>
                    </div>
                    <input className="fsf-stations-update-postcode__submit" type="submit" value="Update" />
                </form>
            </div>
        );
    }

    _highlightSort(value) {
        if (this.props.sorting === value) {
            return ' sort-selected';
        }

        return '';
    }

    _onPostcodeChange(evt) {
        this.props.onPostcodeUpdate(evt.target.value);
    }

    _onQuantityChange(evt) {
        this.props.onQuantityChange(evt.target.value);
    }
}

export default FinderStationListHeaderComponent;
